import { useTranslation } from 'react-i18next'

import { EntityTabAttributes } from '../../EntityTab'

import { USER_PROFILE_TAB_ATTRIBUTES_QA_NAME } from './UserProfileTabAttributes.constants'

function UserProfileTabAttributes({ userData }) {
  const { t } = useTranslation()

  return (
    <EntityTabAttributes
      attributes={userData?.attributes}
      qaName={USER_PROFILE_TAB_ATTRIBUTES_QA_NAME}
      title={t('UserProfileTabAttributes.TitleKey')}
    />
  )
}

export default UserProfileTabAttributes
